const getProductChangeOfAddress2ndPhase = (state) => {
	return state;
};

const getProductChangeOfAddress2ndPhaseShoppingCartId = (state) => {
	return state.shoppingCartId;
};

const getProductChangeOfAddress2ndPhaseStatus = (state) => {
	return state.status;
};

const getChangeOfAddress2ndPhaseSelectedProduct = (state) => {
	return state.selectedProduct;
};

export default {
	getProductChangeOfAddress2ndPhase,
	getProductChangeOfAddress2ndPhaseShoppingCartId,
	getProductChangeOfAddress2ndPhaseStatus,
	getChangeOfAddress2ndPhaseSelectedProduct
};
